<ng-template #errorCampo let-clave="clave">
  <div class="cf-field__error" *ngIf="mensaje(clave) as texto"><mat-icon>error</mat-icon> {{ texto }}</div>
</ng-template>

<div class="m184-page">

  <ng-container *ngIf="isLoading">
    <div class="m184-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Cargando datos...</p>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">

    <div class="m184-header">
      <div class="m184-header__icon"><mat-icon>groups</mat-icon></div>
      <div>
        <h5 class="m184-header__title">Modelo 184</h5>
        <p class="m184-header__sub">Declaración informativa anual de entidades en régimen de atribución de rentas</p>
      </div>
    </div>

    <div class="m184-actions">
      <button mat-stroked-button class="cf-btn" (click)="calcular()">
        <mat-icon>refresh</mat-icon> Calcular
      </button>
      <button mat-stroked-button class="cf-btn" (click)="validate()">
        <mat-icon>search</mat-icon> Validar
      </button>
      <button mat-stroked-button class="cf-btn" (click)="saveDraft()" [disabled]="isSaving">
        <mat-icon>save</mat-icon> Guardar borrador
      </button>
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="getFile()">
        <mat-icon>file_download</mat-icon> Descargar fichero
      </button>
      <button mat-stroked-button class="cf-btn" [matMenuTriggerFor]="masAcciones">
        <mat-icon>more_horiz</mat-icon> Más
      </button>
      <mat-menu #masAcciones="matMenu">
        <button mat-menu-item (click)="ficheroImportado.click()">
          <mat-icon>upload_file</mat-icon> Importar fichero
        </button>
        <button mat-menu-item (click)="openHistory()">
          <mat-icon>history</mat-icon> Historial de presentaciones
        </button>
        <button mat-menu-item (click)="marcarPresentada()" [disabled]="!declaracionActual">
          <mat-icon>check_circle</mat-icon> Marcar como presentada
        </button>
        <button mat-menu-item (click)="redirectFileTax()" [disabled]="!path">
          <mat-icon>send</mat-icon> Presentar en la sede
        </button>
        <button mat-menu-item (click)="descartarBorrador()" [disabled]="!declaracionActual">
          <mat-icon>restore</mat-icon> Descartar borrador
        </button>
      </mat-menu>
      <input #ficheroImportado type="file" accept=".184,.txt" hidden (change)="importFile($event)" />
      <span class="m184-actions__spacer"></span>

      <button mat-stroked-button class="cf-btn" (click)="alternarTodo()">
        <mat-icon>{{ todoCompactado ? 'unfold_more' : 'unfold_less' }}</mat-icon>
        {{ todoCompactado ? 'Expandir todo' : 'Compactar todo' }}
      </button>
    </div>

    <div class="m184-alerts" *ngIf="validations.length">
      <div class="m184-alert" *ngFor="let item of validations; trackBy: trackByIndex"
        [class.m184-alert--warning]="item.type === 'WARNING'">
        <mat-icon>{{ item.type === 'WARNING' ? 'warning' : 'error_outline' }}</mat-icon>
        <span class="m184-alert__text">{{ item.message }}</span>
        <button type="button" *ngIf="item.key" class="m184-alert__link" (click)="irAlCampo(item)">
          {{ etiquetaSalto(item) }}
        </button>
      </div>
    </div>

    <div class="m184-layout">

      <aside class="m184-rail">
        <div class="m184-rail__block">
          <label class="m184-rail__label" for="buscador">Buscador de campos</label>
          <div class="m184-rail__buscador">
            <input id="buscador" class="m184-input m184-rail__input" name="buscador" type="text"
              placeholder="NIF" [(ngModel)]="buscadorCampo" (keyup.enter)="irAlCampoBuscado()" />
            <button mat-flat-button class="cf-btn cf-btn--primary" (click)="irAlCampoBuscado()">Ir al campo</button>
          </div>
        </div>

        <div class="m184-rail__block">
          <span class="m184-rail__label">Estado</span>
          <span class="m184-pill m184-pill--{{ varianteDeclaracion }}">{{ estadoDeclaracion }}</span>
          <span class="m184-rail__nota" *ngIf="declaracionActual?.fileName">{{ declaracionActual.fileName }}</span>
        </div>

        <div class="m184-rail__block">
          <span class="m184-rail__label">Secciones</span>
          <button type="button" class="m184-rail__seccion" *ngFor="let seccion of secciones; let i = index"
            [class.m184-rail__seccion--activa]="seccionActiva === seccion.clave" (click)="irALaSeccion(seccion.clave)">
            <span class="m184-rail__seccion-texto">
              <span class="m184-rail__seccion-numero">{{ i + 1 }} -</span>
              {{ seccion.titulo }}
            </span>
            <mat-icon class="m184-rail__seccion-check" *ngIf="confirmada(seccion.clave)">check_circle</mat-icon>
            <span class="m184-rail__seccion-hueco" *ngIf="!confirmada(seccion.clave)"></span>
          </button>
        </div>
      </aside>

      <div class="m184-sections">

        <div class="m184-card" id="region-declarante" [class.m184-card--collapsed]="colapsada('declarante')">
          <div class="m184-card__head" (click)="toggleRegion('declarante')">
            <mat-icon>perm_identity</mat-icon>
            <span class="m184-card__head-label">1 - Declarante</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('declarante')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('declarante') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-card__body">
            <div class="m184-fields">
              <div class="m184-field m184-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('sujetoNIF')">
                <app-ui-input id="sujetoNIF" name="sujetoNIF" [(ngModel)]="data.sujetoNIF"
                  [config]="{ label: 'NIF de la entidad', maxLength: 9 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sujetoNIF' }"></ng-container>
              </div>
              <div class="m184-field m184-field--6 cf-field--required" [class.cf-field--invalid]="!!mensaje('sujetoDenominacion')">
                <app-ui-input id="sujetoDenominacion" name="sujetoDenominacion" [(ngModel)]="data.sujetoDenominacion"
                  [config]="{ label: 'Denominación o razón social de la entidad' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sujetoDenominacion' }"></ng-container>
              </div>
              <div class="m184-field m184-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('ejercicio')">
                <app-select id="ejercicio" name="ejercicio" [ngModel]="ejercicioSel"
                  (ngModelChange)="ejercicioSel = $event; cambiarEjercicio()"
                  [config]="{ label: 'Ejercicio', options: ejercicioOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'ejercicio' }"></ng-container>
              </div>
              <div class="m184-field m184-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('telefono')">
                <app-ui-input id="telefono" name="telefono" [(ngModel)]="data.telefono"
                  [config]="{ label: 'Teléfono', maxLength: 9, inputmode: 'tel' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'telefono' }"></ng-container>
              </div>
              <div class="m184-field m184-field--9 cf-field--required" [class.cf-field--invalid]="!!mensaje('contacto')">
                <app-ui-input id="contacto" name="contacto" [(ngModel)]="data.contacto"
                  [config]="{ label: 'Apellidos y nombre de la persona con quien relacionarse' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'contacto' }"></ng-container>
              </div>
            </div>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declarante')">
              <mat-icon>check</mat-icon> Declarante confirmado
            </button>
          </div>
        </div>

        <div class="m184-card" id="region-declaracion" [class.m184-card--collapsed]="colapsada('declaracion')">
          <div class="m184-card__head" (click)="toggleRegion('declaracion')">
            <mat-icon>description</mat-icon>
            <span class="m184-card__head-label">2 - Declaración</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('declaracion')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('declaracion') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-card__body">
            <div class="m184-fields">
              <div class="m184-field m184-field--4" [class.cf-field--invalid]="!!mensaje('sustitutiva')">
                <app-select id="sustitutiva" name="tipoDeclaracion" [ngModel]="tipoSel"
                  (ngModelChange)="onTipo($event)"
                  [config]="{ label: 'Tipo de declaración', options: tipoDeclaracionOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sustitutiva' }"></ng-container>
              </div>
              <div class="m184-field m184-field--4" *ngIf="esAnterior" [class.cf-field--invalid]="!!mensaje('justificanteAnterior')">
                <app-ui-input id="justificanteAnterior" name="justificanteAnterior" [ngModel]="data.justificanteAnterior"
                  (ngModelChange)="onJustificanteAnterior($event)"
                  [config]="{ label: 'Nº de justificante de la declaración anterior', maxLength: 13 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'justificanteAnterior' }"></ng-container>
              </div>
              <div class="m184-field m184-field--4 cf-field--required" [class.cf-field--invalid]="!!mensaje('justificante')">
                <app-ui-input id="justificante" name="justificante" [(ngModel)]="data.justificante"
                  [config]="{ label: 'Nº de justificante de esta declaración', maxLength: 13 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'justificante' }"></ng-container>
              </div>
            </div>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declaracion')">
              <mat-icon>check</mat-icon> Declaración confirmada
            </button>
          </div>
        </div>

        <div class="m184-card" id="region-entidad" [class.m184-card--collapsed]="colapsada('entidad')">
          <div class="m184-card__head" (click)="toggleRegion('entidad')">
            <mat-icon>apartment</mat-icon>
            <span class="m184-card__head-label">3 - Entidad</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('entidad')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('entidad') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-card__body">
            <div class="m184-fields">
              <div class="m184-field m184-field--4 cf-field--required" [class.cf-field--invalid]="!!mensaje('tipoEntidad')">
                <app-select id="tipoEntidad" name="tipoEntidad" [(ngModel)]="data.tipoEntidad"
                  [config]="{ label: 'Tipo de entidad', options: tipoEntidadOptions, placeholder: 'Seleccionar' }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'tipoEntidad' }"></ng-container>
              </div>
              <div class="m184-field m184-field--8 cf-field--required" [class.cf-field--invalid]="!!mensaje('actividadPrincipal')">
                <app-select id="actividadPrincipal" name="actividadPrincipal" [(ngModel)]="data.actividadPrincipal"
                  [config]="{ label: 'Actividad principal', options: actividadOptions, placeholder: 'Seleccionar' }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'actividadPrincipal' }"></ng-container>
              </div>
              <div class="m184-field m184-field--6" [class.cf-field--invalid]="!!mensaje('extranjeroTipo')">
                <app-select id="extranjeroTipo" name="extranjeroTipo" [ngModel]="data.extranjeroTipo"
                  (ngModelChange)="onExtranjeroTipo($event)"
                  [config]="{ label: 'Entidad constituida en el extranjero', options: extranjeroTipoOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'extranjeroTipo' }"></ng-container>
              </div>
              <div class="m184-field m184-field--4" *ngIf="data.extranjeroTipo" [class.cf-field--invalid]="!!mensaje('extranjeroObjeto')">
                <app-select id="extranjeroObjeto" name="extranjeroObjeto" [(ngModel)]="data.extranjeroObjeto"
                  [config]="{ label: 'Objeto de la entidad extranjera', options: extranjeroObjetoOptions, placeholder: 'Seleccionar' }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'extranjeroObjeto' }"></ng-container>
              </div>
              <div class="m184-field m184-field--2" *ngIf="data.extranjeroTipo" [class.cf-field--invalid]="!!mensaje('extranjeroPais')">
                <app-ui-input id="extranjeroPais" name="extranjeroPais" [(ngModel)]="data.extranjeroPais"
                  [config]="{ label: 'Clave de país', maxLength: 2 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'extranjeroPais' }"></ng-container>
              </div>
              <div class="m184-field m184-field--4" [class.cf-field--invalid]="!!mensaje('porcentajeResidentes')">
                <app-ui-input id="porcentajeResidentes" name="porcentajeResidentes" [(ngModel)]="data.porcentajeResidentes"
                  [config]="{ label: 'Porcentaje de renta atribuible a miembros residentes', type: 'number', step: '0.01', inputmode: 'decimal' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'porcentajeResidentes' }"></ng-container>
              </div>
              <div class="m184-field m184-field--4">
                <app-select id="tributaIS" name="tributaIS" [ngModel]="tributaSN" (ngModelChange)="onTributa($event)"
                  [config]="{ label: 'Todos los miembros tributan en el Impuesto sobre Sociedades', options: sinoOptions }"></app-select>
              </div>
              <div class="m184-field m184-field--4" [class.cf-field--invalid]="!!mensaje('cifraNegocios')">
                <app-ui-input id="cifraNegocios" name="cifraNegocios" [(ngModel)]="data.cifraNegocios"
                  [config]="{ label: 'Importe neto de la cifra de negocios', type: 'number', step: '0.01', inputmode: 'decimal' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'cifraNegocios' }"></ng-container>
              </div>
              <div class="m184-field m184-field--3" [class.cf-field--invalid]="!!mensaje('representanteNIF')">
                <app-ui-input id="representanteNIF" name="representanteNIF" [(ngModel)]="data.representanteNIF"
                  [config]="{ label: 'NIF del representante', maxLength: 9 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'representanteNIF' }"></ng-container>
              </div>
              <div class="m184-field m184-field--9" [class.cf-field--invalid]="!!mensaje('representanteNombre')">
                <app-ui-input id="representanteNombre" name="representanteNombre" [(ngModel)]="data.representanteNombre"
                  [config]="{ label: 'Apellidos y nombre o razón social del representante' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'representanteNombre' }"></ng-container>
              </div>
            </div>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('entidad')">
              <mat-icon>check</mat-icon> Entidad confirmada
            </button>
          </div>
        </div>

        <div class="m184-card" id="region-rentas" [class.m184-card--collapsed]="colapsada('rentas')">
          <div class="m184-card__head" (click)="toggleRegion('rentas')">
            <mat-icon>account_balance</mat-icon>
            <span class="m184-card__head-label">4 - Rentas</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('rentas')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('rentas') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-card__body" id="rentas">
            <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'rentas' }"></ng-container>
            <app-model-184-rentas [data]="data" [validaciones]="validations"
              (nuevo)="nuevaRenta()" (editar)="editarRenta($event)" (eliminar)="eliminarRenta($event)"
              (origen)="verOrigen($event)"></app-model-184-rentas>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('rentas')">
              <mat-icon>check</mat-icon> Rentas confirmadas
            </button>
          </div>
        </div>

        <div class="m184-card" id="region-miembros" [class.m184-card--collapsed]="colapsada('miembros')">
          <div class="m184-card__head" (click)="toggleRegion('miembros')">
            <mat-icon>groups</mat-icon>
            <span class="m184-card__head-label">5 - Miembros</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('miembros')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('miembros') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-card__body" id="miembros">
            <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'miembros' }"></ng-container>
            <app-model-184-miembros [data]="data" [validaciones]="validations"
              (nuevo)="nuevoMiembro()" (editar)="editarMiembro($event)"
              (eliminar)="eliminarMiembro($event)"></app-model-184-miembros>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('miembros')">
              <mat-icon>check</mat-icon> Miembros confirmados
            </button>
          </div>
        </div>

        <div class="m184-card" id="region-atribuciones" [class.m184-card--collapsed]="colapsada('atribuciones')">
          <div class="m184-card__head" (click)="toggleRegion('atribuciones')">
            <mat-icon>summarize</mat-icon>
            <span class="m184-card__head-label">6 - Atribuciones</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('atribuciones')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('atribuciones') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-atribuciones">
            <table class="m184-tabla-simple">
              <thead>
                <tr>
                  <th>NIF</th>
                  <th>Miembro</th>
                  <th>Clave de la entidad</th>
                  <th>Clave del miembro</th>
                  <th class="m184-num">Importe</th>
                  <th class="m184-num">Reducción</th>
                  <th class="m184-num">Provisiones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let fila of data.atribuciones; trackBy: trackByIndex">
                  <td>{{ fila.nifMiembro }}</td>
                  <td>{{ fila.nombreMiembro }}</td>
                  <td>{{ fila.claveEntidad }}{{ fila.subclaveEntidad ? ' / ' + fila.subclaveEntidad : '' }}</td>
                  <td>{{ fila.clave }}{{ fila.subclave ? ' / ' + fila.subclave : '' }}</td>
                  <td class="m184-num">{{ fila.importe | number:'1.2-2' }} €</td>
                  <td class="m184-num">{{ fila.reduccion | number:'1.2-2' }} €</td>
                  <td class="m184-num">{{ fila.provisiones | number:'1.2-2' }} €</td>
                </tr>
                <tr *ngIf="!data.atribuciones.length">
                  <td colspan="7" class="m184-vacio">No hay rentas atribuidas a los miembros</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('atribuciones')">
              <mat-icon>check</mat-icon> Atribuciones confirmadas
            </button>
          </div>
        </div>

        <div class="m184-card" id="region-presentacion" [class.m184-card--collapsed]="colapsada('presentacion')">
          <div class="m184-card__head" (click)="toggleRegion('presentacion')">
            <mat-icon>send</mat-icon>
            <span class="m184-card__head-label">7 - Presentación</span>
            <mat-icon class="m184-card__check" *ngIf="confirmada('presentacion')">check_circle</mat-icon>
            <mat-icon class="m184-card__chevron">{{ colapsada('presentacion') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m184-card__body">
            <div class="m184-presentar">
              <div class="m184-alerts" *ngIf="data.avisos.length">
                <div class="m184-alert m184-alert--warning" *ngFor="let aviso of data.avisos; trackBy: trackByIndex">
                  <mat-icon>warning</mat-icon>
                  <span class="m184-alert__text">{{ aviso }}</span>
                </div>
              </div>

              <div class="m184-guia" *ngIf="mostrarGuia">
                <div class="m184-guia__head">
                  <mat-icon>task_alt</mat-icon>
                  <span>Ya tienes el fichero <strong>{{ nombreFichero }}</strong>. Para presentarlo:</span>
                  <button type="button" class="m184-guia__close" (click)="mostrarGuia = false">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <ol class="m184-guia__pasos">
                  <li>Entra en la sede electrónica de la Agencia Tributaria con tu certificado.</li>
                  <li>Elige el modelo 184 y la opción de presentar con fichero.</li>
                  <li>Selecciona el fichero descargado.</li>
                  <li>Revisa, firma y presenta. Luego vuelve aquí y márcala como presentada.</li>
                </ol>
              </div>

              <div class="m184-presentar__acciones">
                <button mat-stroked-button class="cf-btn" (click)="validate()">
                  <mat-icon>search</mat-icon> Validar
                </button>
                <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="getFile()">
                  <mat-icon>file_download</mat-icon> Descargar fichero
                </button>
                <button mat-stroked-button class="cf-btn" (click)="redirectFileTax()" [disabled]="!path">
                  <mat-icon>open_in_new</mat-icon> Presentar en la sede
                </button>
                <button mat-stroked-button class="cf-btn" (click)="marcarPresentada()" [disabled]="!declaracionActual">
                  <mat-icon>check_circle</mat-icon> Marcar como presentada
                </button>
              </div>
            </div>
          </div>
          <div class="m184-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('presentacion')">
              <mat-icon>check</mat-icon> Presentación confirmada
            </button>
          </div>
        </div>

      </div>
    </div>

  </ng-container>
</div>
